/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Update_Timing_On_EditInputs */

const en_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Timing On Edit`)
};

const fr_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le minutage lors de l'édition`)
};

const de_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierungszeitpunkt beim Bearbeiten`)
};

const it_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna i tempi di modifica`)
};

const ru_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление времени при редактировании`)
};

const es_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar tiempo al editar`)
};

const zh_cn2_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑更新时间`)
};

const ja_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集時の更新タイミング`)
};

const hi_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादन पर समय अपडेट करें`)
};

const pt_pt2_options_editor_update_timing_on_edit = /** @type {(inputs: Options_Editor_Update_Timing_On_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar tempo na edição`)
};

/**
* | output |
* | --- |
* | "Update Timing On Edit" |
*
* @param {Options_Editor_Update_Timing_On_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_update_timing_on_edit = /** @type {((inputs?: Options_Editor_Update_Timing_On_EditInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Update_Timing_On_EditInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_update_timing_on_edit(inputs)
	if (locale === "de") return de_options_editor_update_timing_on_edit(inputs)
	if (locale === "it") return it_options_editor_update_timing_on_edit(inputs)
	if (locale === "ru") return ru_options_editor_update_timing_on_edit(inputs)
	if (locale === "es") return es_options_editor_update_timing_on_edit(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_update_timing_on_edit(inputs)
	if (locale === "ja") return ja_options_editor_update_timing_on_edit(inputs)
	if (locale === "hi") return hi_options_editor_update_timing_on_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_update_timing_on_edit(inputs)
	return en_options_editor_update_timing_on_edit(inputs)
});